import { C14SidePhotoContentCardCarouselProps } from './C14SidePhotoContentCardCarousel.types';
import { SIDE_PHOTO_CONTENT_CARDS } from 'src/shared/static';
import { Text, Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { Container, SidePhotoContentCardCarousel } from '@ahc-digital/component-library';
import { CreateSidePhotoContentCardCarouselModel } from './C14SidePhotoContentCardCarousel.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export const Default = (props?: C14SidePhotoContentCardCarouselProps) => {
  const phKey = SIDE_PHOTO_CONTENT_CARDS + `-${props?.params?.DynamicPlaceholderId}`;
  const { sitecoreContext } = useSitecoreContext();
  const { renderRichText, renderLink } = useConditionalRendering();
  const isEditing = sitecoreContext?.pageEditing;
  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <>
      {isEditing ? (
        <div className="component-content">
          <strong>
            <i>
              **Note: Carousel rendering parameter updates will be visible on the rendered page**
            </i>
          </strong>
          <Container>
            <Text field={props?.fields?.Headline} />
            {renderRichText(props?.fields?.SupportCopy)}
          </Container>
          <Placeholder name={phKey} rendering={props.rendering} />
          <Container>
            {renderRichText(props?.fields?.BottomSupportCopy)}
            {renderLink(props?.fields?.CTA)}
          </Container>
        </div>
      ) : (
        <SidePhotoContentCardCarousel
          {...CreateSidePhotoContentCardCarouselModel(props)}
          id={props?.params?.AnchorLinkTargetName}
          className={translationClasses(props?.params)}
        />
      )}
    </>
  );
};
